// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2CjaO","radioRow":"SimpleQuestionBuilderModal_radioRow__2Ckor"};